import { z } from 'zod';

function getURL(presentationId: string, filename: string) {
    return `/presentations/${presentationId}/${filename}`;
}

const slideDecoder = z.object({
    headline: z.string(),
    audioPath: z.string(),
    imagePath: z.string(),
    text: z.string().catch(''),
});
const presentationJsonDecoder = z
    .object({
        initialSlide: slideDecoder.transform(({ text, headline, ...rest }) => ({
            ...rest,
            headline: text,
            text: headline,
        })),
        finalSlide: slideDecoder,
        slides: z.array(slideDecoder),
        presentationId: z.string(),
    })
    .transform(({ initialSlide, finalSlide, slides, presentationId }) => ({
        storyTitle: slides[0].headline,
        coverImage: getURL(presentationId, initialSlide.imagePath),
        slides: [initialSlide, ...slides, finalSlide].map(
            ({ headline, audioPath, imagePath, text }) => ({
                headline,
                audioPath: getURL(presentationId, audioPath),
                imagePath: getURL(presentationId, imagePath),
                text,
            })
        ),
    }));

export type StoryData = z.output<typeof presentationJsonDecoder>;
export async function loadPresentationJson(id: string): Promise<StoryData> {
    try {
        const result = await fetch(`/presentations/${id}/index.json`);
        const data = await result.json();

        return presentationJsonDecoder.parse(data);
    } catch (e) {
        console.error('Error fetching presentation json', e);
        throw e;
    }
}
